module.exports = __webpack_public_path__ + "img/veloshop.ca_MSA1__1551460476_76.67.188.141.6e01099d.jpg";